import type {SvgIconProps} from '@mui/material';
import {SvgIcon} from '@mui/material';
import {memo} from 'react';

export const Destination = memo((props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{
        width: 'var(--size, 24px)',
        height: 'var(--size, 24px)',
        ...(props.style ?? {}),
      }}
    >
      <path d="M4.43171 12.1149C3.81333 12.4676 3.87079 13.4082 4.53021 13.6817L8.36909 15.2813V18.1059C8.36909 18.6008 8.76858 19 9.2638 19C9.5292 19 9.781 18.8824 9.9506 18.6773L11.6471 16.6457L15.0372 18.0566C15.5543 18.2727 16.1536 17.9336 16.2384 17.3813L17.9896 6.00635C18.0415 5.67549 17.8965 5.3419 17.6202 5.15323C17.3438 4.96456 16.9826 4.94815 16.6899 5.11495L4.43171 12.1149ZM5.85726 12.8122L15.2014 7.47743L9.1927 14.1875L9.2255 14.2149L5.85726 12.8122ZM15.0263 16.632L10.4678 14.7317L16.3259 8.18836L15.0263 16.632Z" />
    </SvgIcon>
  );
});
Destination.displayName = 'Destination';
